<script setup>
import { RouterLink } from 'vue-router'
import { ROUTES } from '../../../core/config/constants.js'
</script>

<template>
  <header class="home-header">
    <div class="container header-container">
      <div class="logo-wrapper">
        <img src="@/assets/logo/logo_transparent.svg" alt="GoFood" class="logo-img" />
        <span class="logo-text">GoFood</span>
      </div>
      <nav class="home-nav">
        <RouterLink :to="{ name: ROUTES.LOGIN }" class="btn-login">
          <svg
            viewBox="0 0 24 24"
            width="18"
            height="18"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
          >
            <path d="M15 3h4a2 2 0 012 2v14a2 2 0 01-2 2h-4" />
            <polyline points="10 17 15 12 10 7" />
            <line x1="15" y1="12" x2="3" y2="12" />
          </svg>
          <span>התחברות</span>
        </RouterLink>
      </nav>
    </div>
  </header>
</template>

<style scoped>
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 var(--spacing-md);
}

@media (min-width: 768px) {
  .container {
    padding: 0 var(--spacing-lg);
  }
}

.home-header {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 100;
  padding: var(--spacing-sm) 0;
  background: rgba(255, 255, 255, 0.95);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

@media (min-width: 768px) {
  .home-header {
    padding: var(--spacing-md) 0;
  }
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.logo-wrapper {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
}

@media (min-width: 768px) {
  .logo-wrapper {
    gap: var(--spacing-sm);
  }
}

.logo-img {
  width: 32px;
  height: 32px;
  border-radius: var(--border-radius);
}

@media (min-width: 768px) {
  .logo-img {
    width: 40px;
    height: 40px;
  }
}

.logo-text {
  font-size: var(--font-size-lg);
  font-weight: var(--font-weight-bold);
  color: #1e293b;
}

@media (min-width: 768px) {
  .logo-text {
    font-size: var(--font-size-xl);
  }
}

.btn-login {
  display: flex;
  align-items: center;
  gap: var(--spacing-xs);
  padding: 8px 16px;
  background: linear-gradient(135deg, #1e293b 0%, #334155 100%);
  color: white;
  border-radius: var(--border-radius-full);
  font-size: var(--font-size-xs);
  font-weight: var(--font-weight-medium);
  text-decoration: none;
  transition: all var(--transition-fast);
  box-shadow: 0 2px 8px rgba(30, 41, 59, 0.3);
}

.btn-login svg {
  width: 14px;
  height: 14px;
}

@media (min-width: 768px) {
  .btn-login {
    gap: var(--spacing-sm);
    padding: 10px 20px;
    font-size: var(--font-size-sm);
  }

  .btn-login svg {
    width: 18px;
    height: 18px;
  }
}

.btn-login:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 16px rgba(30, 41, 59, 0.5);
}
</style>
